import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Loading, Text } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import AppContext from '@/common/context/app.context'
import useMerchantInventoryLocations from '@/common/hooks/useMerchantInventoryLocations/useMerchantInventoryLocations'

import useAccountPreferences from './hooks/useAccountPreferences/useAccountPreferences'
import MentionsConfiguration from './MentionsConfiguration/MentionsConfiguration'
import RestockConfiguration from './RestockConfiguration/RestockConfiguration'
import StoreByDefaultConfiguration from './StoreByDefaultConfiguration/StoreByDefaultConfiguration'
import * as Styles from './styles'

const PreferencesConfiguration = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { inventoryLocationsByStore, fetchingInventoryLocations } = useMerchantInventoryLocations()
  const {
    loading,
    hasChanges,
    savePreferences,
    revertChanges,
    mentionsNotifications,
    setMentionsNotifications,
    storeByDefault,
    setStoreByDefault,
    storePreferences,
    setStorePreferences,
  } = useAccountPreferences({
    storeId: info?.selectedStore?.id,
    userId: info?.userInfo?.id,
  })

  return (
    <Styles.MainContainer>
      {hasChanges && <UnsavedChangesAlert />}
      <Loading show={loading || fetchingInventoryLocations}>
        <Text type="bodyMRegular">
          {t('Configura tus preferencias sobre el comportamiento del panel para tu usuario.')}
        </Text>
        <StoreByDefaultConfiguration stores={info?.stores} value={storeByDefault} onChange={setStoreByDefault} />
        <MentionsConfiguration
          mentionsNotificationsValue={mentionsNotifications}
          onChangeMentionNotifications={setMentionsNotifications}
        />
        <RestockConfiguration
          storePreferences={storePreferences}
          inventoryLocationsByStore={inventoryLocationsByStore}
          onChangeLocation={setStorePreferences}
        />
        <SaveChangesButtons
          hasChanges={hasChanges}
          onSave={savePreferences}
          onRevertChanges={revertChanges}
          loading={loading}
          disabled={loading}
        />
      </Loading>
    </Styles.MainContainer>
  )
}

export default PreferencesConfiguration
